import { render, staticRenderFns } from "./OsCampaignForm.vue?vue&type=template&id=e2bd0aa6&scoped=true"
import script from "./OsCampaignForm.vue?vue&type=script&lang=ts"
export * from "./OsCampaignForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2bd0aa6",
  null
  
)

export default component.exports